(function scrollToTop($, Drupal) {
  Drupal.behaviors.scrollToTop = {
    attach(context) {
      window.addEventListener('scroll', () => {
        // Determine the distance from top on scroll
        let height = document.documentElement ? document.documentElement.scrollTop : document.scrollingElement.scrollTop;

        // Fall back for iOS since document.documentElement.scrollTo = 0
        if (height === 0) {
          height = document.scrollingElement.scrollTop;
        }

        if (height >= 100) { // If page is scrolled more than 99px
          $('#scroll-to-top', context).fadeIn(350); // Button fades in
        }
        else {
          $('#scroll-to-top', context).fadeOut(350); // Else button fades out
        }
      });
      $('#scroll-to-top', context).click(() => { // When the arrow is clicked
        $('html, body').animate({
          scrollTop: 0, // Scroll to the top of body
        }, 500);
        return false;  // Ensuring the href action is not called
      });
    },
  };
}(jQuery, Drupal));
